import styled from 'styled-components'
import { SCREEN_SIZE } from '../../../../lib/Media'
import FacebookMaintenaceIcon from '../icons/FacebookMaintenace'
import TwitterMaintenaceIcon from '../icons/TwitterMaintenace'
import YouTubeMaintenaceIcon from '../icons/YouTubeMaintenace'
import TruckLogoMaintenaceIcon from '../icons/TruckLogoMaintenace'
import LinkedInMaintenaceIcon from '../icons/LinkedInMaintenace'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.fadedBlue};
  ${SCREEN_SIZE.From.Tablet} {
    overflow-y: hidden;
  }
`
export const Center = styled.div`
  padding: 6rem;
  text-align: center;
  ${SCREEN_SIZE.Below.MobileL} {
    overflow-x: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`
export const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
`
export const StyledMessage = styled.div`
  font-size: ${({ setFont }) => (setFont ? '2rem' : '1.2rem')};
  color: ${({ theme, setBlue }) => (setBlue ? theme.red : theme.darkGray)};
  padding: ${({ setPadding }) => setPadding && '1rem'};
  width: 60%;
  margin: ${({ setMargin }) => (setMargin ? '0 auto 1rem' : '0 auto')};
  font-weight: ${({ setBold }) => setBold && '600'};
`
export const StyledLink = styled.a`
  font-size: 1.2rem;
  padding: 0.5rem;
  color: ${({ theme }) => theme && theme.red};
`
export const FacebookMaintenace = styled(FacebookMaintenaceIcon)`
  height: 3rem;
  width: 3rem;
`
export const TwitterMaintenace = styled(TwitterMaintenaceIcon)`
  height: 3rem;
  width: 3rem;
`
export const YouTubeMaintenace = styled(YouTubeMaintenaceIcon)`
  height: 3rem;
  width: 3rem;
`
export const TruckLogoMaintenace = styled(TruckLogoMaintenaceIcon)`
  height: 9rem;
  ${SCREEN_SIZE.Below.MobileL} {
    width: 10rem;
    height: 10rem;
  }
`

export const LinkedInMaintenace = styled(LinkedInMaintenaceIcon)`
  height: 3rem;
  width: 3rem;
`
export const StyledFollusUs = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme && theme.darkGray};
  width: 60%;
  margin: 3rem auto auto;
  font-weight: ${({ setBold }) => setBold && '600'};
`
export const MaintenanceWrp = styled.div`
  height: 9rem;
  ${SCREEN_SIZE.Below.MobileL} {
    width: 10rem;
    height: 10rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
export const Maintenance = styled.div`
  height: inherit;
  ${SCREEN_SIZE.Below.MobileL} {
    width: 10rem;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const MaintenanceImg = styled.img`
  height: inherit;
  width: inherit;
`
